module.exports = __webpack_public_path__ + "static/img/3-banner-default.d2edcdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-banner-default.jpg
// module id = U/rx
// module chunks = 0